import { Heading } from "@eisox/design-system";

import { m } from "~/paraglide/messages";

import type { Season } from "../helpers";

interface SetpointSeasonBlockProps {
  season: Season;
  children: React.ReactNode;
}

/** The settings of one season, under its title. */
const SetpointSeasonBlock: React.FC<SetpointSeasonBlockProps> = ({ season, children }) => (
  <div className="gap-2.5 flex flex-col">
    <Heading className="text-base text-primary-dark-blue" as="h4">
      {{
        summer: m.summer,
        winter: m.winter,
      }[season]()}
    </Heading>
    {children}
  </div>
);

SetpointSeasonBlock.displayName = "SetpointSeasonBlock";

export { SetpointSeasonBlock };
export type { SetpointSeasonBlockProps };
